import { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import Fact from '../../../../Shared/Fact';
import { SeverityAndTitleFactHelper } from './severity-and-title-fact.helper';

export default function SeverityAndTitleFact({ trafficSituation, className = '' }: { trafficSituation: ITrafficSituation; className?: string }): React.ReactNode | null {
  if (!trafficSituation) return null;

  return (
    <Fact {...SeverityAndTitleFactHelper.getSeverityIcon(trafficSituation.severity)} altText={SeverityAndTitleFactHelper.getSeverityIconAltText(trafficSituation.severity)} className={className}>
      <h3 className="text-break mb-0">{trafficSituation.title}</h3>
    </Fact>
  );
}
